import React, {PureComponent} from 'react'
import axios from 'axios'

import {SaveButton} from '../elements/Button'
import Input from '../elements/Input'

class PrintLabels extends PureComponent {
  constructor(props){
    super(props)
    this.state = {
      copies: props.copies || 1,
      printing: false,
      xml: "",
    }
  }

  componentDidMount(){
    this.print()
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.printing && !prevState.printing){
      this.sendToPrinter(this.state.xml, this.state.copies);
    }
  }

  print = () => {
    axios({
      method: 'POST',
      url:`${process.env.REACT_APP_URL}/requisitions/xml`,
      data: {
        patientID: this.props.patientID,
      }
    }).then(res => {
      if(this.props.printOnload){
        this.sendToPrinter(res.data.data, this.state.copies)
      }
      this.setState({xml: res.data.data})
    }).catch(err =>{})
  }

  sendToPrinter(xml, copies){
    try{
      let label = window.dymo.label.framework.openLabelXml(xml);
      let printParamsXml = window.dymo.label.framework.createLabelWriterPrintParamsXml({copies: copies});
      window.dymo.label.framework.printLabelAsync(this.props.printer, printParamsXml, label).then((a,b,c,d) => {
        this.setState({printing: false})
      })
    } catch(e){
      console.log(e)
    }
  }

  onPrint = () => {
    this.setState({printing: true})
  }

  render(){
    return (
      <div className="input-group">
        <Input type="number" property="copies" value={this.state.copies+""} onChange={(key,value) => this.setState({[key]:parseInt(value, 10) || 1})} />
        <span className="input-group-btn">
          <SaveButton type="primary" onClick={this.onPrint} saving={this.state.printing}><i className="fa fa-tags"></i> Print Labels</SaveButton>
        </span>
      </div>
    )
  }
}

export default PrintLabels
